<div class="right-panel h-100 text-grey">
  <div
    class="actionBar mt-0"
    [ngClass]="currentActiveEntityConfigurator ? 'mt-0' : ''"
  >
    <div class="flex-grow-1">
      <input
        class="search"
        type="text"
        placeholder="Search by name or action"
        [(ngModel)]="filterText"
        (ngModelChange)="onSearch()"
      />
    </div>
    <button
      type="button"
      class="actionBtn"
      (click)="refreshComponent()"
      placement="top auto"
      triggers="hover" ngbTooltip="Refresh Logs"
    >
      <span class="bi bi-arrow-clockwise"></span>
      <span class="button-animation">&nbsp;Refresh</span>
    </button>
    <button
      type="button"
      class="actionBtn"
      (click)="toggleFilters()"
      placement="top auto"
      container="body"
      triggers="hover" ngbTooltip="Show/Hide Filters"
    >
      <span class="bi bi-funnel"></span>
      <span class="button-animation">&nbsp;Filters</span>
    </button>
    <button
      type="button"
      *ngIf="showDelete && isGlobalAdmin"
      class="actionBtn"
      title="Delete Selected Action Logs"
      (click)="deleteActionLog()"
      triggers="hover" ngbTooltip="Delete Logs"
    >
      <span class="bi bi-trash3"></span>
    </button>
    <div class="newDir h-100" ngbDropdown container="body">
      <button
        type="button"
        class="actionBtn"
        title="Download Action Logs"
        ngbDropdownToggle
      >
        <i class="bi bi-download"></i>
      </button>
      <div ngbDropdownMenu>
        <button
          ngbDropdownItem
          title="Download Currently Fetched Logs"
          (click)="downloadActionLogs(false)"
        >
          <i class="bi bi-file-earmark-arrow-down"></i>
          Download Logs
        </button>
        <button
          ngbDropdownItem
          title="Download All Action Logs"
          (click)="downloadActionLogs(true)"
        >
          <i class="bi bi-file-earmark-arrow-down-fill"></i>
          Download All Logs
        </button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="toShowFilter">
    <div class="actionBar" style="margin-bottom: 8px">
      <div ngDeafaultControl
           *ngIf="logNumberEntries.length > 0"
           style="
         margin-right: 4px;
         color: var(--s-primary-color);
         font-size: 12px;
         margin-top: 17px;
       ">
        <h3 class="from">From {{ startRange }} To</h3>
      </div>

      <ng-select name="showEntries"
                 *ngIf="logNumberEntries.length > 0"
                 class="searchFilter full-width-dropdown"
                 [(ngModel)]="entries"
                 ngDefaultControl
                 (ngModelChange)="loadLogsDataForRange(entries)"
                 [clearable]="false"
                 style="margin-right: 4px"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option *ngFor="let entries of logNumberEntries; let i = index"
                   [value]="entries"
                   [title]="entries.toString()"
                   class="full-text-option">
          {{ entries }}
        </ng-option>
      </ng-select>
      &nbsp;

      <ng-select name="actionEntity"
                 *ngIf="selectedDataType == 'Deployment'"
                 class="actionBarFilter full-width-dropdown"
                 [(ngModel)]="entityFilterValue"
                 (ngModelChange)="applyFilter()"
                 [clearable]="false"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option value="Deployment"
                   title="All Entities"
                   class="full-text-option"
                   style="margin-top: -4px">All Entities</ng-option>
        <ng-option *ngFor="let actionType of allActionEntities"
                   [title]="actionType"
                   [value]="actionType"
                   class="full-text-option">
          {{ actionType }}
        </ng-option>
      </ng-select>

      <ng-select name="actionType"
                 *ngIf="selectedDataType == 'Session'"
                 class="actionBarFilter full-width-dropdown"
                 [(ngModel)]="depName"
                 (ngModelChange)="applyFilter()"
                 [clearable]="false"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option value="all"
                   title="All Deployment"
                   class="full-text-option">All Deployment</ng-option>
        <ng-option *ngFor="let actionType of actionPaths"
                   [title]="actionType"
                   [value]="actionType"
                   class="full-text-option">
          {{ actionType }}
        </ng-option>
      </ng-select>

      <ng-select name="actionType"
                 *ngIf="selectedDataType == 'Session'"
                 class="actionBarFilter full-width-dropdown"
                 [(ngModel)]="actionEntityName"
                 (ngModelChange)="applyFilter()"
                 [clearable]="false"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option value="all"
                   title="All Workstation"
                   class="full-text-option">All Workstation</ng-option>
        <ng-option *ngFor="let actionType of entityNames"
                   [title]="actionType"
                   [value]="actionType"
                   class="full-text-option">
          {{ actionType }}
        </ng-option>
      </ng-select>

      <ng-select name="actionType"
                 class="actionBarFilter full-width-dropdown"
                 [(ngModel)]="actionFilterValue"
                 (ngModelChange)="applyFilter()"
                 [clearable]="false"
                 [searchable]="false"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option value="all"
                   title="All Actions"
                   class="full-text-option">All Actions</ng-option>
        <ng-option *ngFor="let actionType of allActionTypes"
                   [title]="actionType"
                   [value]="actionType"
                   class="full-text-option">
          {{ actionType }}
        </ng-option>
      </ng-select>

      <ng-select name="actionLevel"
                 class="actionBarFilter full-width-dropdown"
                 [(ngModel)]="actionLevelFilterValue"
                 (ngModelChange)="applyFilter()"
                 [clearable]="false"
                 [searchable]="false"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option [value]="10"
                   title="All Types"
                   class="full-text-option">All Types</ng-option>
        <ng-option *ngFor="let actionLevel of allActionLevels"
                   [value]="actionLevel"
                   [title]="getActionLevelName(actionLevel)"
                   class="full-text-option">
          {{ getActionLevelName(actionLevel) }}
        </ng-option>
      </ng-select>

      <ng-select name="initiator"
                 class="actionBarFilter full-width-dropdown"
                 [(ngModel)]="initiatorFilterValue"
                 (ngModelChange)="applyFilter()"
                 [clearable]="false"
                 [searchable]="false"
                 dropdownClass="full-width-dropdown-panel">
        <ng-option value="all"
                   title="All Initiators"
                   class="full-text-option">All Initiators</ng-option>
        <ng-option *ngFor="let initiator of allInitiators"
                   [title]="initiator"
                   [value]="initiator"
                   class="full-text-option">
          {{ initiator }}
        </ng-option>
      </ng-select>

      <button type="button"
              class="actionBtn"
              title="Reset applied filters"
              (click)="resetFilter()"
              #btnResetFilter
              placement="top auto"
              triggers="hover"
              ngbTooltip="Reset Filters">
        <span class="bi bi-x-lg text-danger"></span>
      </button>
    </div>
  </ng-container>

  <div class="logTable" style="white-space: nowrap">
    <div
      [ngStyle]="{ 'flex-grow': dataAvailable ? '1' : '' }"
      class="overflow-auto"
    >
      <table
        class="table table-striped"
        dynamicPagination
        [rowHeight]="29"
        [offsetHeight]="200"
        [paginationInstance]="config"
      >
        <thead>
          <tr>
            <th resizable>
              <input
                (change)="onSelectAllCheckBox($event)"
                [checked]="selectAll"
                type="checkbox"
                title="Checking this will select all the action logs available"
              />
            </th>
            <th resizable>#</th>
            <th resizable>Name</th>
            <th resizable *ngIf="shouldShowColumn">
              {{ getColumnName() }}
            </th>
            <th resizable>Action</th>
            <th resizable>Type</th>
            <th resizable>Initiator</th>
            <th resizable (click)="sortByTime()">
              Time
              <span
                style="cursor: pointer"
                *ngIf="dataAvailable"
                [ngClass]="
                  sortDate == 1 ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                "
                class="bi"
              ></span>
            </th>
            <th resizable>Status</th>
            <th resizable *ngIf="selectedDataType == 'application'">
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="
              let action of actionLogs
                | paginate
                  : {
                      itemsPerPage: logsNumberToShow,
                      currentPage: p
                    };
              let i = index
            "
          >
            <tr>
              <td>
                <input
                  type="checkbox"
                  name=""
                  id=""
                  [checked]="selectedActionLogs.includes(action.actionLogId)"
                  (change)="onCheckboxSelect($event, action.actionLogId)"
                />
              </td>
              <td scope="row">{{ startRange - 1 + action.actionIndex }}</td>
              <td>{{ action.entityName }}</td>
              <td *ngIf="shouldShowColumn">{{ action.entityPath }}</td>
              <td>
                {{ action.action }}
                <i
                  class="bi bi-info-circle-fill synchpc-primary float-end pe-4"
                  placement="bottom-left"
                  container="body"
                  [autoClose]="true"
                  triggers="hover" [ngbTooltip]="action?.description"
                >
                </i>
              </td>
              <td>{{ getActionLevelName(action?.actionLevel) }}</td>
              <td>{{ action.initiator }}</td>
              <td>{{ action.actionTime }}</td>
              <td>{{ action.actionStatus }}</td>
              <td *ngIf="selectedDataType == 'application'">
                <button
                  *ngIf="action.description"
                  class="btn btn-sm"
                  (click)="toggleRowDetails(action, action.isExpanded)"
                >
                  <span>
                    <i
                      [ngClass]="{
                        'bi-chevron-bar-down': action.isExpanded,
                        'bi-chevron-bar-left': !action.isExpanded
                      }"
                    ></i>
                  </span>
                </button>
              </td>
            </tr>
            <tr
              *ngIf="action.isExpanded && selectedDataType == 'application'"
              class="details-row expanded-details"
            >
              <td
                colspan="10"
                style="padding: 10px !important; white-space: pre-wrap"
              >
                {{ action.description ? action.description : "NA" }}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    @if (dataAvailable) {
    <div class="pagination-container">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <input
          class="pagination-input"
          style="border: 1px solid var(--s-primary-color)"
          placeholder="Entries Per Page"
          type="number"
          [value]="logsNumberToShow"
          (change)="paginationEntries($event)"
        />
        <button
          class="default-btn"
          style="
            height: 24px;
            border-radius: 0px;
            border-left: none;
            background-color: white;
          "
          (click)="showAllEntriesMethod()"
        >
          Go
        </button>
      </div>
      <pagination-controls class="my-pagination" (pageChange)="p = $event">
      </pagination-controls>
    </div>
    } @else {
    <p class="errorMsg">{{ errorText }}</p>
    }
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
  >
    <p class="pleaseWait">Please wait ...</p>
  </ngx-spinner>
</div>
